import type { TaskCalendarEvent } from 'src/components/locality/VesselTasksCalendarDialog'
import type { IScheduledTask } from 'src/generated-types/scheduledTask'

export interface TaskFilterDateRange {
  startDate?: Date | null
  endDate?: Date | null
}

export interface TaskFilterFormValues extends TaskFilterDateRange {
  resource?: { id: EntityId }[]
  locality?: { id: EntityId }[]
  search?: string
  signedStatus?: string
}

export interface TaskFilterQueryParams extends TaskFilterDateRange {
  resourceIds?: string
  localityIds?: string
  isSigned?: boolean
  search?: string
}

export interface BuiltTaskFilter {
  queryParams: TaskFilterQueryParams
  searchInput: string
  filterDates: TaskFilterDateRange
}

export const buildTaskFilterQueryParams = (
  formValues: TaskFilterFormValues,
  { isCalendar, calendarRange }: { isCalendar: boolean; calendarRange: TaskFilterDateRange },
): BuiltTaskFilter => {
  const queryParams: TaskFilterQueryParams = {
    resourceIds: formValues.resource?.map(resource => resource.id).join(',') || '',
    localityIds: formValues.locality?.map(locality => locality.id).join(',') || '',
    startDate: isCalendar ? calendarRange.startDate : formValues.startDate,
    endDate: isCalendar ? calendarRange.endDate : formValues.endDate,
  }

  if (formValues.signedStatus === 'signed') queryParams.isSigned = true
  else if (formValues.signedStatus === 'unsigned') queryParams.isSigned = false

  return {
    queryParams,
    searchInput: typeof formValues.search === 'string' ? formValues.search : '',
    filterDates: { startDate: formValues.startDate, endDate: formValues.endDate },
  }
}

export const mergeSearchIntoQueryParams = (queryParams: TaskFilterQueryParams, search: string): TaskFilterQueryParams =>
  search ? { ...queryParams, search } : queryParams

export const mapScheduledTasksToCalendarEvents = (scheduledTasks?: IScheduledTask[]): TaskCalendarEvent[] =>
  scheduledTasks?.map(scheduledTask => ({
    id: scheduledTask.id,
    title: scheduledTask.tasks.title,
    startDate: scheduledTask.startDate,
    endDate: scheduledTask.endDate,
    locality: scheduledTask.tasks.locality,
    localityName: scheduledTask.tasks.locality?.name,
    task: scheduledTask.tasks,
  })) ?? []
